import React from 'react';
import { Grid, Row, Col } from '@vds/grids';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

import { isMobile } from '../../../../common/Helpers';
import SubHeader from '../../../../common/Heading/subhead';
import VdsTooltip from '../../../../common/Tooltip';
import '../creditCheck.css';

const SubHeading = (props) => {
  const parseSubHeading = (refundableSubHeading) => {
    const refundableParse = parse(refundableSubHeading);
    return refundableParse;
  };
  const { subHeadingNew, subHeadingRefundableNew, subHeadingRefundableMobile, creditReviewSuccessResponse, toolTipText } = props;
  const isEid = creditReviewSuccessResponse?.eidQuestionnaire?.numOfQuestions > 0;
  let refundableSubHeading = subHeadingNew;

  if (isMobile()) {
    refundableSubHeading = subHeadingRefundableMobile;
  } else {
    refundableSubHeading = subHeadingRefundableNew;
  }

  if (refundableSubHeading) {
    refundableSubHeading = parseSubHeading(refundableSubHeading);
  }
  return (
    <Grid>
      <Row className="CreditHeaderWrapper SubHeadWrapper">
        <Col className={isMobile() ? '' : 'noLeftPad'} colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
          {isEid ? (
            ''
          ) : (
            <SubHeader
              subHeading={[
                refundableSubHeading,
                <VdsTooltip ariaLabel="More information tooltip" size="small" iconFillColor="secondary" surface="light" className="headerTooltip">
                  {toolTipText}{' '}
                </VdsTooltip>,
              ]}
              width={isMobile() ? '341px' : '808px'}
              primitive="p"
              color="secondary"
            />
          )}
        </Col>
      </Row>
    </Grid>
  );
};
SubHeading.propTypes = {
  subHeadingNew: PropTypes.string,
  toolTipText: PropTypes.string,
  subHeadingRefundableMobile: PropTypes.string,
  subHeadingRefundableNew: PropTypes.string,
  creditReviewSuccessResponse: PropTypes.object,
};

export default React.memo(SubHeading);
